module.exports = __webpack_public_path__ + "static/media/favourite.9dce950b.svg";